import actionTypes from '../constants/action-types';

const pageTemplateHTML = (state = {}, action) => {
  if (action.type !== actionTypes.SET_PAGE_TEMPLATE_HTML) return state;
  if (action.payload.pageTemplateId !== state.id) return state;

  return {
    ...state,
    html: action.payload.html,
  };
};

export default pageTemplateHTML;
